import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import './index.css'
import { InvalidSession, initSSO } from './sso-client'
import { bootstrapDemoMode, isDemoMode } from './lib/demoMode'

async function bootstrap() {
  await bootstrapDemoMode()

  if (!isDemoMode()) {
    try {
      await initSSO()
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Sessao invalida.'
      ReactDOM.createRoot(document.getElementById('root')).render(
        <InvalidSession message={message} />,
      )
      return
    }
  }

  const { default: App } = await import('./App.jsx')

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
}

void bootstrap()
